import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Layout, Menu, MenuProps, Popover } from 'antd';
import { IRouteV2 } from 'data';
import { commonHooks } from 'hooks';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { showError } from 'store/popup/actions';
import { t } from 'helpers/i18n';
import { CollapseIcon, ExpandIcon } from 'v2/containers/Icons';
import ProjectListPopup from '../components/ProjectListPopup';
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import { buildItems } from '../../../util/menu';
import { RenderIconInfo } from 'rc-menu/lib/interface';
import ProjectHeadIcon from '../components/ProjectHeadIcon';
import './AppSider.scss';

const { Sider } = Layout;
const { useAppMenu } = commonHooks;

interface AppSiderProps {
  filteredNavigation: IRouteV2[];
}

const AppSider: React.FC<AppSiderProps> = props => {
  const params = useParams<any>();
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const { projects, projectsError } = useSelector(
    (state: RootState) => state.projectList
  );
  const { data: project } = useSelector(
    (state: RootState) => state.projectDetail.project
  );

  // Get selectedKey, openKey from route & pathname
  const { filteredNavigation } = props;
  const { selectedKey, openKey } = useAppMenu(filteredNavigation);

  const items = buildItems(params, collapsed, filteredNavigation);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const history = useHistory();
  const onClick: MenuProps['onClick'] = e => {
    history.push(e.key);
  };

  const expandIcon = (props: RenderIconInfo) => {
    if (collapsed) {
      return null;
    }
    return props.isOpen ? (
      <CaretUpFilled className="menu-arrow-icon" />
    ) : (
      <CaretDownFilled className="menu-arrow-icon" />
    );
  };

  return (
    <Sider
      id="app-sider"
      className={`app-sider`}
      trigger={null}
      width={collapsed ? 88 : 288}
    >
      <Popover
        className="ant-popover-placement-right"
        placement={'rightTop'}
        arrowPointAtCenter={true}
        content={<ProjectListPopup currentProject={project} />}
      >
        <div className="project-logo">
          <ProjectHeadIcon
            project={project}
            collapsed={collapsed}
            onClick={() => {
              if (projectsError && projects.length === 0) {
                dispatch(showError(t('cannot_get_projects')));
              }
            }}
          />
        </div>
      </Popover>

      <Menu
        inlineCollapsed={collapsed}
        style={{ width: collapsed ? 88 : 288, background: 'transparent' }}
        className="app-menu"
        defaultOpenKeys={[openKey]}
        selectedKeys={[selectedKey]}
        mode="inline"
        items={items}
        expandIcon={expandIcon}
        onClick={onClick}
      />
      <div
        className="app-footer"
        onClick={toggleCollapse}
        style={{ width: collapsed ? 88 : 288 }}
      >
        {collapsed ? (
          <div className="app-icon">{ExpandIcon}</div>
        ) : (
          <div className="expanded-footer">
            <div className="app-icon">{CollapseIcon}</div>
            <span style={{ marginLeft: 16 }}>{t('Collapse')}</span>
          </div>
        )}
      </div>
    </Sider>
  );
};

export default AppSider;
